import { EpdLinks } from 'routes/EpdRoutes';
import { EPDCopyGroupStatus, EpdGroupDashboardModel } from 'services/EpdClient';
import { EPDGroupCardDashboardStatus } from 'styles/v2/Styles.styled';
import { formatDate } from 'util/utils';
import { CardName, CardSmallText, CopyGroupCard } from './styles';
import { confirmInfo } from 'components/v2/confirm-dialog/confirmInfo';
import AuthService from 'services/AuthService';

type TProps = {
  epdGroup: EpdGroupDashboardModel;
  background: any;
};

const EpdGroupCard = ({ epdGroup, background }: TProps) => {
  const groupStatus =
    epdGroup.status === EPDCopyGroupStatus.ApprovedByLicenseeAdmin
      ? 'Sent for publication'
      : epdGroup.status === EPDCopyGroupStatus.DeclinedCopyByLicenseeAdmin
      ? 'Declined publication'
      : epdGroup.status;

  const handleCardClick = (e: React.MouseEvent<HTMLElement>) => {
    if (AuthService.isAdmin() || AuthService.isLicenseeAdmin()) {
      return;
    }
    e.preventDefault();
    confirmInfo({
      caption: 'Copy function is temporarily unavailable.',
      description: (
        <>
          <strong>Dear customers</strong>,
          <br />
          <br />
          Unfortunately, this feature will be temporarily unavailable for a few weeks due to necessary updates. We expect it
          to be back up and running after August.
          <br />
          <br />
          Thank you for your patience and understanding.
        </>
      ),
    });
  };

  return (
    <CopyGroupCard to={EpdLinks.editCopyEpd(epdGroup.id)} background={background} onClick={handleCardClick}>
      <CardName>{epdGroup.name}</CardName>
      <div>
        <CardSmallText>Copy group</CardSmallText>
        <CardSmallText>Created: {formatDate(epdGroup?.createdAt)}</CardSmallText>
        <EPDGroupCardDashboardStatus status={epdGroup.status}>{groupStatus}</EPDGroupCardDashboardStatus>
      </div>
    </CopyGroupCard>
  );
};

export default EpdGroupCard;
